import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { Paginator } from "primeng/paginator";
import { TableConfig } from "@app/shared/util/table-config.utils";

@Component({
    selector: 'app-pagination',
    templateUrl: 'pagination.component.html',
    styleUrls: ['pagination.component.scss']
})

export class PaginationComponent implements OnChanges {

    @ViewChild(Paginator, {static: false}) paginator: Paginator;

    @Input() filter: boolean;
    @Input() pagination: TableConfig;

    @Output() pageChange = new EventEmitter();

    state: any;

    // This is used for forcing the paginator to refresh its state once new pages come from afar
    seen = true;


    constructor(private cdr: ChangeDetectorRef) {
    }

    ngOnChanges(changes: import("@angular/core").SimpleChanges): void {
        if (changes['pagination']) {
            this.seen = false;
            this.state = this.pagination.pager;
            setTimeout(() => {
                this.seen = true;
            })
        }
    }


    get computePages() {
        if (this.state.groupToolCount > 0) {
            return this.state.groupToolCount;
        } else {
            return this.state.count;
        }
    }

    setPage(config) {
        this.state.page = config.page + 1;
        this.pageChange.emit(this.state.page);
    }

    updatePage(page) {
        this.paginator?.changePage(page - 1);
    }

    get currentPage() {
        return (this.state?.page - 1) * this.state.pageSize;
    }
}
